import TransHTML from '~components/transHTML';
import styled from 'styled-components';

type PricingFeatureProps = {
    feature: string;
    isBulletPlus?: boolean;
};

export const PricingFeature = ({
    feature,
    isBulletPlus,
}: PricingFeatureProps) => {
    return (
        <ItemList bulletPlus={isBulletPlus}>
            <TransHTML id={feature} />
        </ItemList>
    );
};

type ItemListProps = {
    bulletPlus?: boolean;
};

const ItemList = styled.li<ItemListProps>`
    list-style: ${props => (props.bulletPlus ? 'none' : '')};
    margin-top: 0.9rem ;

    &:before {
        content: '${props => props.bulletPlus && ' +'}';
        color: ${({ theme }) => theme.greenColor};
        position: absolute;
        left: 0;
    }

    a {
        font-weight: 700;
    }
`;
